import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChargingCardInputModel } from './charging-card-input.model';

@Injectable()
export class ChargingCardInputMapper {
  constructor(private translateService: TranslateService) {}

  public map(): ChargingCardInputModel {
    return {
      items: this.getItems(),
    };
  }

  private getItems(): string[] {
    return [
      marker('modules.evsb.chargingCard.input.list.1.item'),
      marker('modules.evsb.chargingCard.input.list.2.item'),
      marker('modules.evsb.chargingCard.input.list.3.item'),
    ];
  }
}
